"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOppositeDirection = getOppositeDirection;

var _constants = require("../constants");

var _types = require("./types");

function getOppositeDirection(direction) {
  if ((0, _types.isStringMatch)(direction, _constants.DIRECTION_ALL)) {
    if ((0, _types.isStringMatch)(direction, _constants.DIRECTION_HORIZONTAL)) {
      return direction === _constants.DIRECTION_HORIZONTAL[0] ? _constants.DIRECTION_HORIZONTAL[1] : _constants.DIRECTION_HORIZONTAL[0];
    }

    if ((0, _types.isStringMatch)(direction, _constants.DIRECTION_VERTICAL)) {
      return direction === _constants.DIRECTION_VERTICAL[0] ? _constants.DIRECTION_VERTICAL[1] : _constants.DIRECTION_VERTICAL[0];
    }
  }

  return null;
}